import { fork, all } from 'redux-saga/effects';

import bootstrapSagas from './queries/sagas/bootstrap';

const sagas = [
  bootstrapSagas
];

function *globalSagas() {
  const globalSagasForks = sagas.map((saga) => fork(saga));

  yield all([...globalSagasForks]);
}

export default globalSagas;

